import Card from '../components/Card';

const ExpiredOrInvalid = () => (
  <main className="mx-auto flex min-h-screen max-w-xl items-center justify-center p-4">
    <Card className="w-full text-center">
      <h1 className="text-xl font-semibold text-slate-900">This link is no longer valid</h1>
      <p className="mt-2 text-sm text-slate-600">
        The quote link you opened has expired or is invalid. If you still need to respond, please ask the
        sender to issue a new link.
      </p>
    </Card>
  </main>
);

export default ExpiredOrInvalid;
